import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';

export function DashboardHeader() {
  return (
    <header className="dashboard-header">
      <div className="dashboard-header-content">
        <Link to="/dashboard" className="dashboard-header-logo">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="2"
              y="2"
              width="28"
              height="28"
              rx="4"
              stroke="currentColor"
              strokeWidth="2"
            />
            <rect x="6" y="6" width="8" height="8" rx="1" fill="currentColor" />
            <rect x="18" y="6" width="8" height="8" rx="1" fill="currentColor" opacity="0.6" />
            <rect x="6" y="18" width="8" height="8" rx="1" fill="currentColor" opacity="0.6" />
            <rect x="18" y="18" width="8" height="8" rx="1" fill="currentColor" opacity="0.3" />
          </svg>
          <span className="dashboard-header-title">PageCraft Studio</span>
        </Link>

        <UserMenu />
      </div>
    </header>
  );
}
